import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What makes Kuze different?',
      answer: 'Kuze is built for live, in-person multiplayer. One host runs the game. Everyone joins from their own phone. No awkward passing devices. No waiting.'
    },
    {
      question: 'Is Kuze free?',
      answer: 'Yes. Kuze includes free base content.Extra packs and add-ons are one-time purchases.No subscriptions. No ads. Ever.'
    },
    {
      question: 'Do we all need the app?',
      answer: 'One player hosts the game in the Kuze app.Everyone else can join from their own phone, either in the app or directly via the web.'
    },
    {
      question: 'How many players can join?',
      answer: 'Kuze works best with 2–10 players in the same room.'
    },
    {
      question: 'Can I play remotely?',
      answer: 'Kuze is designed for people physically together. It\'s best experienced face to face.'
    },
    {
      question: 'Is it online?',
      answer: 'Kuze is built for in-person multiplayer. You’ll need an internet connection to join and play together.'
    },
    {
      question: 'Is it NSFW?',
      answer: 'Some packs are mild. Some are very not. You choose.'
    },
    {
      question: 'Age rating?',
      answer: 'Kuze is designed for adults 18+. Some content is explicitly mature.'
    }
  ];

  return (
    <section id="faq" className="py-24 px-6">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-[#01DE9E]" style={{ lineHeight: '1.3' }}>
          FAQ
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-900/40 to-gray-800/40 backdrop-blur-sm border border-gray-700/30 rounded-2xl overflow-hidden hover:border-gray-600/50 transition-all"
            >
              <button
                id={`faq-btn-${index}`}
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer"
              >
                <h3 className="text-xl font-bold pr-4">{faq.question}</h3>
                <i className={`${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'} text-2xl text-purple-400 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div
                  id={`faq-answer-${index}`}
                  role="region"
                  aria-labelledby={`faq-btn-${index}`}
                  className="px-8 pb-6"
                >
                  <p className="text-gray-400 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
